<div class="split-comparison-container">
  <div class="comparison-header">
    <div class="comparison-selectors">
      <div class="face-label">
        <span>Face 1</span>
      </div>
      <span class="vs-text">VS</span>
      <div class="face-label">
        <span>Face 2</span>
      </div>
    </div>
    <button class="close-btn" (click)="closeDialog()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="comparison-area"
       (mousemove)="onSplitDrag($event)"
       (mouseup)="endSplitDrag()"
       (mouseleave)="endSplitDrag()">

    <div class="image-panel"
         [style.clip-path]="'inset(0 ' + (100 - splitPosition) + '% 0 0)'"
         (wheel)="onWheel($event, 1)">
      <img
        [src]="getFaceImage(0)"
        [alt]="'Face 1'"
        class="comparison-image"
        [style.transform]="'scale(' + image1Zoom + ') translate(' + image1PanX + 'px, ' + image1PanY + 'px)'"
        (mousedown)="startPan($event, 1)"
        (mousemove)="onPan($event, 1)"
        (mouseup)="endPan(1)"
        (mouseleave)="endPan(1)"
        #image1>
    </div>

    <div class="image-panel"
         [style.clip-path]="'inset(0 0 0 ' + splitPosition + '%)'"
         (wheel)="onWheel($event, 2)">
      <img
        [src]="getFaceImage(1)"
        [alt]="'Face 2'"
        class="comparison-image"
        [style.transform]="'scale(' + image2Zoom + ') translate(' + image2PanX + 'px, ' + image2PanY + 'px)'"
        (mousedown)="startPan($event, 2)"
        (mousemove)="onPan($event, 2)"
        (mouseup)="endPan(2)"
        (mouseleave)="endPan(2)"
        #image2>
    </div>

    <div class="split-slider"
         [style.left]="splitPosition + '%'"
         (mousedown)="startSplitDrag($event)">
      <div class="split-handle">
        <div class="handle-circle">
          <i class="bi bi-chevron-left"></i>
          <i class="bi bi-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="control-panel">
    <div class="image-controls">
      <div class="zoom-controls">
        <label class="zoom-label">Zoom</label>
        <input
          class="zoom-slider"
          type="range"
          min="0.5"
          max="10"
          step="0.1"
          [(ngModel)]="image1Zoom"
          (input)="onZoomChange(1, $event)">
        <span class="zoom-value">{{ image1Zoom }}x</span>
      </div>
      <button class="reset-btn" (click)="resetImage(1)">Reset</button>
    </div>

    <div class="image-controls">
      <div class="zoom-controls">
        <label class="zoom-label">Zoom</label>
        <input
          class="zoom-slider"
          type="range"
          min="0.5"
          max="10"
          step="0.1"
          [(ngModel)]="image2Zoom"
          (input)="onZoomChange(2, $event)">
        <span class="zoom-value">{{ image2Zoom }}x</span>
      </div>
      <button class="reset-btn" (click)="resetImage(2)">Reset</button>
    </div>
  </div>
</div>
